import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinners from "components/Common/Spinner";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";

const Home = () => {
  const [newURL, setNewURL] = useState(null);
  const [error, setError] = useState(null);
  const token = JSON.parse(localStorage.getItem("Token"));
  const acadId = localStorage.getItem("acad_id");
  const liveUrl = "https://marcopolo.prisms.in";
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !acadId) {
      setError("Authentication failed");
      return;
    }

    const fetchUrl = async () => {
      try {
        const { data } = await axios.post(`${liveUrl}/api/parent-payfees/getLink`, 
          { acad_id: acadId },
          { headers: { Authorization: token } }
        );
        setNewURL(data.url);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch the URL");
      }
    };

    fetchUrl();
  }, [token, acadId]);

  useEffect(() => {
    if (newURL) {
      window.history.pushState(null, "", "/dashboard");
      const timer = setTimeout(() => (window.location.href = newURL), 500);
      const handlePopState = () => navigate("/dashboard");
      window.addEventListener("popstate", handlePopState);
      return () => {
        clearTimeout(timer);
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [newURL, navigate]);

  if (error) {
    return (
      <div className="page-content text-center text-danger">
        <h4>{error}</h4>
      </div>
    );
  }

  if (!newURL) {
    return (
      <div className="page-content">
        <Spinners />
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container>
        <Card>
          <CardBody>
            <h4 className="fs-5 text-center text-dark">Redirecting...</h4>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Home;
